import { render, staticRenderFns } from "./ReceiveTask.vue?vue&type=template&id=aaf485d0&scoped=true&"
import script from "./ReceiveTask.vue?vue&type=script&lang=js&"
export * from "./ReceiveTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaf485d0",
  null
  
)

export default component.exports